function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Platform, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { Colors, Spacer, Text, Icon } from 'advance-components';
import RightMenuItem from './right-menu-item';
import HelpMenuItem from './help-menu-item';
import colorTheme from './color-theme';
const Container = styled.View`
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme === 'default' ? Colors.indigo400 : Colors.white;
}};
  padding-horizontal: 24px;
  padding-vertical: 12px;
  flex-direction: row;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
`;
const FlexRow = styled.View`
  flex-direction: row;
`;
const MenuPressable = styled.Pressable`
  flex-direction: row;
`;
const Logo = styled.Image`
  height: 24px;
  width: 132.57px;
  cursor: pointer;
`;
const DropDownMenu = styled.View`
  position: absolute;
  top: 64px;
  right: 24px;
  background-color: ${Colors.white};
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
`;
const DropDownHelpMenuContainer = styled.View`
  position: relative;
`;
const DropDownHelpMenuActiveContainer = styled.View`
  position: absolute;
  top: 45px;
  right: 0;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
`;
const NotificationContainer = styled.View`
  position: relative;
`;
const NotificationActiveContainer = styled.View`
  position: absolute;
  top: 45px;
  right: 0;
`;
const NotificationDot = styled.Pressable`
  background-color: ${Colors.error400};
  height: 18px;
  width: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border-width: 2px;
  border-color: ${Colors.white};
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 9999;
`;
export default function MainMenu(props) {
  const {
    theme,
    mainMenuItems,
    dropdownItems,
    dropdownHelpMenuItems,
    fullName,
    logo,
    onLogoPress,
    renderNotifications,
    notificationActive,
    setNotificationActive,
    unreadNotificationsCount
  } = props;
  const [active, setActive] = useState(false);
  const [helpMenuActive, setHelpMenuActive] = useState(false);
  return /*#__PURE__*/React.createElement(Container, {
    theme: theme
  }, /*#__PURE__*/React.createElement(FlexRow, null, /*#__PURE__*/React.createElement(Pressable, {
    onPress: onLogoPress
  }, Platform.select({
    web: /*#__PURE__*/React.createElement(Logo, {
      source: {
        uri: logo
      },
      resizeMode: "contain"
    }),
    default: /*#__PURE__*/React.createElement(Logo, {
      source: logo,
      resizeMode: "contain"
    })
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  }), /*#__PURE__*/React.createElement(FlexRow, null, mainMenuItems.filter(_ref2 => {
    let {
      position
    } = _ref2;
    return position !== 'right';
  }).map((menuItem, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: colorTheme[theme].textColor,
    onPress: menuItem.onPress,
    href: menuItem.href
  }, menuItem.label), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  }))))), /*#__PURE__*/React.createElement(FlexRow, null, mainMenuItems.filter(_ref3 => {
    let {
      position
    } = _ref3;
    return position === 'right';
  }).map((menuItem, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: colorTheme[theme].textColor,
    onPress: menuItem.onPress,
    href: menuItem.href
  }, menuItem.label), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  }))), /*#__PURE__*/React.createElement(NotificationContainer, null, /*#__PURE__*/React.createElement(Icon.MaterialCommunityIcons, {
    name: "bell",
    size: 24,
    color: colorTheme[theme].iconColor,
    onPress: () => {
      setActive(false);
      setHelpMenuActive(false);
      setNotificationActive(!notificationActive);
    }
  }), unreadNotificationsCount > 0 && /*#__PURE__*/React.createElement(NotificationDot, {
    onPress: () => {
      setActive(false);
      setHelpMenuActive(false);
      setNotificationActive(!notificationActive);
    }
  }, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.white,
    align: "center"
  }, unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount)), notificationActive && /*#__PURE__*/React.createElement(NotificationActiveContainer, null, renderNotifications())), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  }), /*#__PURE__*/React.createElement(DropDownHelpMenuContainer, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "help",
    size: 24,
    color: colorTheme[theme].iconColor,
    onPress: () => {
      setActive(false);
      setHelpMenuActive(!helpMenuActive);
      setNotificationActive(false);
    }
  }), helpMenuActive && /*#__PURE__*/React.createElement(DropDownHelpMenuActiveContainer, null, dropdownHelpMenuItems.map((dropdownItem, index) => /*#__PURE__*/React.createElement(HelpMenuItem, _extends({
    key: index
  }, dropdownItem))))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  }), /*#__PURE__*/React.createElement(MenuPressable, {
    onPress: () => {
      setActive(!active);
      setHelpMenuActive(false);
      setNotificationActive(false);
    }
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    color: colorTheme[theme].textColor
  }, fullName), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  }), /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "keyboard-arrow-down",
    size: 24,
    color: colorTheme[theme].textColor
  }))), active && /*#__PURE__*/React.createElement(DropDownMenu, null, dropdownItems.map((dropdownItem, index) => /*#__PURE__*/React.createElement(RightMenuItem, _extends({
    key: index
  }, dropdownItem)))));
}
MainMenu.defaultProps = {
  theme: 'default',
  mainMenuItems: [],
  dropdownItems: [],
  dropdownHelpMenuItems: [],
  fullName: '',
  logo: '',
  onLogoPress: () => null,
  renderNotifications: () => null,
  notificationActive: false,
  setNotificationActive: () => null,
  unreadNotificationsCount: 0
};
MainMenu.propTypes = {
  theme: PropTypes.oneOf(['default', 'light']),
  mainMenuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    href: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right'])
  })),
  dropdownItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.string,
    onPress: PropTypes.func,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string,
      onPress: PropTypes.func,
      subItems: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string,
        onPress: PropTypes.func
      }))
    }))
  })),
  dropdownHelpMenuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onPress: PropTypes.func
  })),
  fullName: PropTypes.string,
  logo: PropTypes.string,
  onLogoPress: PropTypes.func,
  renderNotifications: PropTypes.func,
  notificationActive: PropTypes.bool,
  setNotificationActive: PropTypes.func,
  unreadNotificationsCount: PropTypes.number
};
//# sourceMappingURL=main-menu.js.map